import React, {
    useState,
    useEffect,
    useLayoutEffect,
    useCallback,
    useContext,
    useRef,
} from "react";

// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
// import { ContextMenu } from "primereact/contextmenu";
// import { InputNumber } from "primereact/inputnumber";
// import { TabView, TabPanel } from "primereact/tabview";
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Checkbox } from 'primereact/checkbox';
import { ToggleButton } from 'primereact/togglebutton';

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumerico } from "../../../isp._comun/iu/componentes/widgets/InputNumerico";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { InputTextarea } from "primereact/inputtextarea";

import GlobalContext     from "../../../isp._comun/iu/contexto/GlobalContext";
import Dialogo         from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import { ModosOp }     from "../../../isp._comun/iu/_principal/constantesIuPrin";

import * as Action from "../../reductores/acciones/dispatch/_ActionsDispatch";
import ActionContratoSet from "../../reductores/acciones/ActionContratoSet";
// import SetTipoServicio from "../../reductores/acciones/dispatch/SetTipoServicio";

// import { TiposDeItem, Moneda, Udm } from "../../../isp.žapi.Servicios/constantesApiServicios";
import {TipoItemLabel, UnidadItemLabel, EstadosItemLabel } from "./žconstantesIuLayoutContratos";

// import { EstadosItemLabel } from "./žConstantes_Items";
import * as ModelosDeCombos from "./ModeloDeCombos_Contratos";

// import ComandoAPI from "../presentadores/ComandoAPI";

const DialogoContratoLayout = ({
    ventana,
    estadoDCF,
    dispatchDCF,
    registrarServicioCommand,
    actualizarServicioCommand,
    buscarUnSoloServicioCommand,
}) => {
    // const { dispatchPrincipal } = useContext(GlobalContext);
    const { eliminarVentana, abrirVentanaSeleccionarCliente } = useContext(GlobalContext);

    // const isMounted = useRef(false);
    const inputnumeral = useRef(null);

    useEffect(() => {
        console.log("use effect se monto el componente padre ----");
        console.log(inputnumeral);
        // inputnumeral.current.maxLength=6;
    }, []);

    useEffect(() => {
        if (estadoDCF.flag.cargandoEntidad) {
            buscarUnSoloServicioCommand.ejecutar(estadoDCF.domain.screen.idItem);
        }
        return () => {};
    }, [estadoDCF.flag.cargandoEntidad]);

    useEffect(() => {
        if (!estadoDCF.flag.procesandoComando) {
            return;
        }

        // let comando = new ComandoAPI();
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
            // comando = registrarServicioCommand;
            // comando = registrarServicioCommand;
            registrarServicioCommand.ejecutar();
            return () => {
                registrarServicioCommand.cancelar();
            };
        }
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
            actualizarServicioCommand.ejecutar();
            return () => {
                actualizarServicioCommand.cancelar();
            };
        }
        /* return () => {
            comando.cancelar();
        }; */
    }, [estadoDCF.flag.procesandoComando]);

    const cancelarClick = (eventoSynDom) => {
        eliminarVentana(ventana);
        // dispatchPrincipal(new EliminarVentana(ventana));
        eventoSynDom.stopPropagation();
    };
    
    const cargarClienteClick = (eventoDom) => {
        // (eventoDom) => cancelarClick(eventoDom)

        abrirVentanaSeleccionarCliente(notificarClienteSeleccionado);
        // eliminarVentana(ventana);
        // dispatchPrincipal(new EliminarVentana(ventana));
        eventoDom.stopPropagation();
    };

    const notificarClienteSeleccionado = ()=>{};

    const header = {
        elementoReact: <p className="p-2 bg-gradient-to-r from-purple-100">Contrato</p>,
        enProgreso: estadoDCF.flag.procesandoComando,
    };

    /* let bloqueTipoDeItem = null;

    if(estadoDCF.flag.modoOperacion === ModosOp.CREAR){
        bloqueTipoDeItem = 
            <Dropdown
                value={estadoDCF.domain.screen.tipoItem}
                options={ModelosDeCombos.tiposItem}                          
                onChange={(e) => {
                    dispatchDCF(new SetTipoServicio("tipoItem", e.value));
                    dispatchDCF(new SetTipoServicio("tipoItem", e.value));
                }}
                className="p-0 w-full rounded-none"
                // panelClassName="p-0"
                // panelStyle={{ padding: 0 }}
                disabled={estadoDCF.flag.procesandoComando}
            />
    }else{
        const labelTipoItem = ModelosDeCombos.tiposItem.find((tipoItem)=>{
            if(tipoItem.value === estadoDCF.domain.screen.tipoItem)return true;
        });
        bloqueTipoDeItem = labelTipoItem.label;
    } */
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    let bloqueCampos01 = (
        <div className="flex justify-between flex-wrap">
            <div>
                <div className="flex">
                    <div className="flex">
                        <div className="w-40">Id. de Contrato : </div>
                        <div>{estadoDCF.domain.screen.idContrato}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                
            </div>    
            <div>
                <div className="flex">
                    <div className="w-40 shrink-0">Fecha de Registro : </div>
                    <div>{estadoDCF.domain.screen.fechaReg}</div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40 shrink-0">Fecha de Inicio : </div>
                    {/* <InputText
                        id="in"
                        value={estadoDCF.domain.screen.fechaInicio}
                        className="p-0 w-32 rounded-none"
                        onChange={(e) =>
                            dispatchDCF(
                                new ActionContratoSet("fechaInicio", e.target.value)
                                // new Action.SetNombres(e.target.value)
                            )
                        }
                        maxLength={10}
                        disabled={estadoDCF.flag.procesandoComando}
                    /> */}
                    <Calendar
                        // panelClassName="w-4"
                        maxDate={new Date()}
                        dateFormat="dd/mm/yy"
                        locale="es" 
                        inputClassName="p-0 w-24 rounded-none"
                        value={estadoDCF.domain.screen.fechaInicio} 
                        onChange={(e) =>
                            dispatchDCF(
                                new ActionContratoSet("fechaInicio", e.value)
                                // new Action.SetNombres(e.target.value)
                            )
                        }
                        maxLength={10}
                        disabled={estadoDCF.flag.procesandoComando}
                    />
                </div>
                <div className="flex mt-1">
                    <div className="w-40">Estado : </div>
                    <div>{estadoDCF.domain.screen.estado}</div>
                </div>
            </div>
        </div>
    );

    let bloqueCampos02 = (
        <div className="flex justify-between flex-wrap">
            
            <div id="columnaIzq">

                <div className="flex">
                        <div className="w-40">Id. de Servicio : </div>
                        <div>{estadoDCF.domain.screen.idServicio}</div>
                        <div className="flex">
                            
                        </div>
                        <div className="flex">
                            <div className="w-40"></div>
                            <div></div>
                        </div>
                    </div>
                    <div className="flex mt-1">
                        <div className="w-40 shrink-0">Minicodigo : </div>
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.minicodigo}
                            className="p-0 w-32 rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionContratoSet("minicodigo", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={10}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <div className="flex">
                            <div className="w-40"></div>
                        </div>       
                </div>

                <hr className="my-2"></hr>
                
                <div className="flex">
                    <div className="flex">
                        <div className="w-32">Id. del Cliente : </div>                        
                        <Button
                            // label="Cancelar"
                            icon="pi pi-caret-right"
                            onClick={(eventoDom) => cargarClienteClick(eventoDom)}
                            // disabled={estadoDCF.flag.procesandoComando}
                            className="p-button-rounded p-button-text p-button-warning w-6 h-6 ml-1"
                            // className="w-32"
                        />
                        <div className="ml-1">{estadoDCF.domain.screen.idCliente}</div>
                    </div>
                    <Button
                        // label="Cancelar"
                        icon="pi pi-bars"
                        onClick={(eventoDom) => cargarClienteClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-outlined p-button-warning w-7 h-6 ml-4"
                        // className="w-32"
                    />
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="flex">
                        <div className="w-40">N° de Doc : </div>
                        <div>{estadoDCF.domain.screen.nroCliente}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="flex">
                        <div className="w-40">Nombre / Cliente : </div>
                        <div>{estadoDCF.domain.screen.nomCliente}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>

                <hr className="my-2"></hr>

                <div className="flex">
                    <div className="flex">
                        <div className="w-32">Id del Plan : </div>
                        <Button
                            // label="Cancelar"
                            icon="pi pi-caret-right"
                            onClick={(eventoDom) => cancelarClick(eventoDom)}
                            // disabled={estadoDCF.flag.procesandoComando}
                            className="p-button-rounded p-button-text p-button-warning w-6 h-6 ml-1"
                            // className="w-32"
                        />
                        <div className="ml-1">{estadoDCF.domain.screen.idPlan}</div>
                    </div>
                    <Button
                        // label="Cancelar"
                        icon="pi pi-bars"
                        onClick={(eventoDom) => cancelarClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-outlined p-button-warning w-7 h-6 ml-4"
                        // className="w-32"
                    />
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="flex">
                        <div className="w-40">Nombre del Plan : </div>
                        <div>{estadoDCF.domain.screen.nomPlan}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>

                <hr className="my-2"></hr>

                <div className="flex">
                    <div className="w-40">Tipo / Comprobante : </div>
                    <div>
                        <Dropdown
                            value={estadoDCF.domain.screen.tipoComp}
                            options={ModelosDeCombos.tiposComprobantesCombo}
                            onChange={(e) => {
                                dispatchDCF(new ActionContratoSet("tipoComp", e.target.value));
                                // dispatchDCF(new Action.SetTipoDoc(e.value));
                            }}
                            placeholder="Seleccionar..."
                            // placeholder="Selecciona un Tipo"
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>

                <div className="flex mt-1">
                    <div className="w-40 shrink-0">Ciclo / Fact. : </div>
                    <div className="pl-0">
                        <Dropdown
                            value={estadoDCF.domain.screen.cicloFact}
                            /* options={ModelosDeCombos.ciclosFactCombo.filter((cicloCombo) => {
                                return estadoDCF.domain.screen.combos.udms.includes(
                                    cicloCombo.value
                                );
                            })} */
                            options={ModelosDeCombos.ciclosFactCombo}
                            onChange={
                                (e) => dispatchDCF(new ActionContratoSet("cicloFact", e.target.value))
                                // dispatchDCF(new Action.SetSexo(e.value))
                            }
                            placeholder="Seleccionar..."
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.sexoBlanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere elegir un Género.
                        </small>
                    </div>
                </div>

            </div>
            
            <div id="columnaDerecha">   
                <div className="flex">
                    <div className="flex">
                        <div className="w-32">Id. / Zona : </div>                        
                        <Button
                            // label="Cancelar"
                            icon="pi pi-caret-right"
                            onClick={(eventoDom) => cancelarClick(eventoDom)}
                            // disabled={estadoDCF.flag.procesandoComando}
                            className="p-button-rounded p-button-text p-button-warning w-6 h-6 ml-1"
                            // className="w-32"
                        />
                        <div className="ml-1">{estadoDCF.domain.screen.idZona}</div>
                    </div>
                    <Button
                        // label="Cancelar"
                        icon="pi pi-bars"
                        onClick={(eventoDom) => cancelarClick(eventoDom)}
                        // disabled={estadoDCF.flag.procesandoComando}
                        className="p-button-rounded p-button-outlined p-button-warning w-7 h-6 ml-4"
                        // className="w-32"
                    />
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40 shrink-0">Nombre / Zona : </div>
                    <div>{estadoDCF.domain.screen.nomZona}</div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40 shrink-0">Direccion : </div>
                    <div className="pl-0">
                        <InputTextarea
                            id="in"
                            value={estadoDCF.domain.screen.direccion}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionContratoSet("direccion", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            rows={3}
                            cols={31}
                            maxLength={100}
                            autoResize={false}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>

                <hr className="my-2"></hr>

                <div className="flex mt-3">
                    <div className="w-40 shrink-0">Pto. PON : </div>
                    <div className="pl-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.ptoPon}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionContratoSet("ptoPon", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={40}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                        >
                            Se requiere Nombres del Item.
                        </small>
                        <small
                            id=""
                            className={estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del Nombre es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40 shrink-0">Caja Distrib. : </div>
                    <div className="pl-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.cajaDistrib}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionContratoSet("cajaDistrib", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={40}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                        >
                            Se requiere Nombres del Item.
                        </small>
                        <small
                            id=""
                            className={estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del Nombre es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40 shrink-0">N° Serie ONT : </div>
                    <div className="pl-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.nroSeONT}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionContratoSet("nroSeONT", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={40}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                        >
                            Se requiere Nombres del Item.
                        </small>
                        <small
                            id=""
                            className={estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del Nombre es incorrecto.
                        </small>
                    </div>
                </div>

                <hr className="my-2"></hr>

                <div className="flex mt-1">
                    <div className="w-40 shrink-0">Aprobado : </div>
                    {/* <Checkbox 
                        className="w-40 shrink-0 self-end" 
                        onChange={(e) =>
                            dispatchDCF(
                                new ActionContratoSet("firmado", e.checked)
                                // new Action.SetNombres(e.target.value)
                            )
                        }
                        checked={estadoDCF.domain.screen.firmado}>
                    </Checkbox> */}
                    <ToggleButton 
                        className="shrink-0 px-2 py-0 self-end"
                        onLabel="Si" 
                        offLabel="No" 
                        onIcon="pi pi-check" 
                        offIcon="pi pi-times" 
                        checked={estadoDCF.domain.screen.aprov} 
                        onChange={(e) =>
                            dispatchDCF(
                                new ActionContratoSet("aprov", e.value)
                                // new Action.SetNombres(e.target.value)
                            )
                        }
                    />
                    {/* <div>{estadoDCF.domain.screen.idItem}</div> */}
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div className="flex mt-1">
                    <div className="w-40 shrink-0">Firmado : </div>
                    {/* <Checkbox 
                        className="w-40 shrink-0 self-end" 
                        onChange={(e) =>
                            dispatchDCF(
                                new ActionContratoSet("firmado", e.checked)
                                // new Action.SetNombres(e.target.value)
                            )
                        }
                        checked={estadoDCF.domain.screen.firmado}>
                    </Checkbox> */}
                    <ToggleButton 
                        className="shrink-0 px-2 py-0 self-end"
                        onLabel="Si" 
                        offLabel="No" 
                        onIcon="pi pi-check" 
                        offIcon="pi pi-times" 
                        checked={estadoDCF.domain.screen.firmado} 
                        onChange={(e) =>
                            dispatchDCF(
                                new ActionContratoSet("firmado", e.value)
                                // new Action.SetNombres(e.target.value)
                            )
                        }
                    />
                    {/* <div>{estadoDCF.domain.screen.idItem}</div> */}
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                
            </div>
            
        </div>
    );

    let bloqueCampos03 = (
        <div className="flex">
            <div className="w-40 shrink-0">Observaciones : </div>
            <div className="pl-0">
                <InputTextarea
                    id="in"
                    value={estadoDCF.domain.screen.observs}
                    className="p-0 w-full rounded-none"
                    onChange={(e) =>
                        dispatchDCF(
                            new ActionContratoSet("observs", e.target.value)
                            // new Action.SetNombres(e.target.value)
                        )
                    }
                    rows={3}
                    cols={31}
                    maxLength={100}
                    autoResize={false}
                    disabled={estadoDCF.flag.procesandoComando}
                />
            </div>
        </div>
    );

    let contenido = null;

    if (estadoDCF.flag.cargandoEntidad) {
        contenido = (
            <>
                <div className="flex flex-row justify-between">
                    <Skeleton width="45%" height="6rem"></Skeleton>
                    <Skeleton width="40%" height="6rem"></Skeleton>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Skeleton width="100%" height="10rem"></Skeleton>
                </div>
            </>
        );
    } else {
        contenido = (
            <>
                {bloqueCampos01}
                {/* <div className="flex justify-between flex-wrap">{bloqueCampos01}</div> */}
                <hr className="my-2"></hr>
                {bloqueCampos02}
                {/* <div className="flex justify-between flex-wrap">{bloqueCampos02}</div> */}
                <hr className="my-2"></hr>
                {bloqueCampos03}
            </>
        );
    }

    const labelBotonAccion = (() => {
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) return "Guardar";
        if (estadoDCF.flag.modoOperacion === ModosOp.OK) return "   OK    ";
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) return "Modificar";
    })();

    const footer = (
        <div>
            <Button
                label={labelBotonAccion}
                icon="pi pi-check"
                onClick={(eventoSynDom) => {
                    if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
                        dispatchDCF(new Action.GuardarContrato());
                        // registrarClienteAFacturar();
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
                        dispatchDCF(new Action.ActualizarContrato());
                        // actualizarClienteAFacturar();
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.OK) {
                        cancelarClick(eventoSynDom);
                        return;
                    }
                }}
                loading={estadoDCF.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoDom) => cancelarClick(eventoDom)}
                disabled={estadoDCF.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    

    return (
        <Dialogo
            ventana={ventana}
            cabecera={header}
            modal={estadoDCF.flag.modal}
            posicionZ={ventana.posicionZ}
            pie={footer}
            estilo={{ width: "63rem", minHeight: "35vh", top: "15vh", margin: "0" }}
        >
            {contenido}
        </Dialogo>
    );
};

export default DialogoContratoLayout;
